import { useMutation, UseMutationOptions } from "react-query";

import {
  BooleanResponse,
  UpdateUserRequest,
  UsersService,
} from "../api/public";

export const useUpdateUserProfile = (
  options?: UseMutationOptions<
    BooleanResponse,
    unknown,
    UpdateUserRequest,
    unknown
  >
) => {
  return useMutation({
    mutationFn: UsersService.usersUpdateUser,
    ...options,
  });
};
